<template>
  <el-radio-group v-model="temData.computeMode">
    <el-radio label="notCount">不计算</el-radio>
    <el-radio label="descOrder">降序排名</el-radio>
    <el-radio label="ascOrder">升序排名</el-radio>
    <el-radio label="propTotal">占比（总值）</el-radio>
    <el-radio label="propRow">占比（指定列）</el-radio>
    <el-radio label="riseValRow">增长值（指定列）</el-radio>
    <el-radio label="riseRateRow">增长率（指定列）</el-radio>
    <el-radio label="propDateOff">占比（时间偏移）</el-radio>
    <el-radio label="riseValDateOff">增长值（时间偏移）</el-radio>
    <el-radio label="riseRateDateOff">增长率（时间偏移）</el-radio>
  </el-radio-group>
  <form-item
      label-width="80"
      class="mt-10"
      labelAlign="left"
      v-if="temData.computeMode === 'propRow' || temData.computeMode === 'riseValRow' || temData.computeMode === 'riseRateRow'"
      label="对比指标"
  >
    <el-select v-model="temData.advancedDateOffset.contrastIndex" clearable size="small">
      <el-option v-for="item in list" :label="item.name" :value="item.code"></el-option>
    </el-select>
  </form-item>
  <template
      v-if="temData.computeMode === 'propDateOff' || temData.computeMode === 'riseValDateOff' || temData.computeMode === 'riseRateDateOff'">
    <DateSet :option="option" class="mt-10" v-if="temData.advancedDateOffset"
             :tem-data="temData.advancedDateOffset"></DateSet>
  </template>
</template>
<script setup>
import {computed} from "vue";
import DateSet from "./dateSet.vue";
import {uniq, uniqBy} from "lodash-es";

let props = defineProps({
  temData: {},
  option: {},
});

if (!props.temData.advancedDateOffset) {
  props.temData.advancedDateOffset = {};
}
let list = computed(() => {
  let res = []
  if (props.option.metrics) {
    res = res.concat(props.option.metrics)
  }
  if (props.option.assistMetrics) {
    res = res.concat(props.option.assistMetrics)
  }
  return res;
});
</script>

<style scoped lang="scss"></style>
